import { browserErrorEmitterPlugin } from '../../emitters';
import { RUMEventName } from '../types';
export const browserEventsRecorder = (windowInstance) => {
    const events = [];
    return {
        addError(error, context) {
            events.push({
                name: RUMEventName.AddError,
                payload: [error, context],
                timestampInMillis: Date.now(),
            });
        },
        init() {
            const emitter = browserErrorEmitterPlugin(windowInstance)(this);
            emitter.start();
        },
        clearUser() {
            events.push({
                name: RUMEventName.ClearUser,
                payload: [],
                timestampInMillis: Date.now(),
            });
        },
        setContext(key, value) {
            events.push({
                name: RUMEventName.SetContext,
                payload: [key, value],
                timestampInMillis: Date.now(),
            });
        },
        setUser(user) {
            events.push({
                name: RUMEventName.SetUser,
                payload: [user],
                timestampInMillis: Date.now(),
            });
        },
        replay(integration) {
            const eventsCopy = events.slice();
            eventsCopy
                .sort((eventA, eventB) => eventA.timestampInMillis - eventB.timestampInMillis)
                .forEach((event) => {
                switch (event.name) {
                    case RUMEventName.AddError:
                        return integration.addError(...event.payload);
                    case RUMEventName.SetUser:
                        return integration.setUser(...event.payload);
                    case RUMEventName.ClearUser:
                        return integration.clearUser();
                    case RUMEventName.SetContext:
                        return integration.setContext(...event.payload);
                    case RUMEventName.AddAction:
                        return integration.addAction(...event.payload);
                    case RUMEventName.SetRouteName:
                        return integration.setRouteName(...event.payload);
                    case RUMEventName.AddTiming:
                        return integration.addTiming(...event.payload);
                }
            });
        },
        addAction(actionName, context) {
            events.push({
                name: RUMEventName.AddAction,
                payload: [actionName, context],
                timestampInMillis: Date.now(),
            });
        },
        setRouteName(name) {
            events.push({
                name: RUMEventName.SetRouteName,
                payload: [name],
                timestampInMillis: Date.now(),
            });
        },
        addTiming(name, time) {
            events.push({
                name: RUMEventName.AddTiming,
                payload: [name, time],
                timestampInMillis: Date.now(),
            });
        },
    };
};
//# sourceMappingURL=index.js.map